import { SET_PAYMENT_METHOD_LIST } from '../constants/PaymentMethod';

export const setPaymentMethodList = (paymentMethodList) => {
  console.log('action setPaymentMethodList');
  return {
    type: SET_PAYMENT_METHOD_LIST,
    paymentMethodList
  };
};
